import { render, staticRenderFns } from "./formItem.vue?vue&type=template&id=919d7eba&scoped=true&"
import script from "./formItem.vue?vue&type=script&lang=js&"
export * from "./formItem.vue?vue&type=script&lang=js&"
import style0 from "./formItem.vue?vue&type=style&index=0&id=919d7eba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919d7eba",
  null
  
)

export default component.exports